module.exports = function loadStore(state, emitter) {
  state.samples = null
  const params = new URLSearchParams(window.location.search);
  const today = new Date()
  const OCTOBER = 9
  const DECEMBER = 11
  state.theme = params.get('theme')
  if (!state.theme){
    if (today.getMonth() === OCTOBER) {
      state.theme =  'halloween'
    } else if (today.getMonth() === DECEMBER){
      state.theme = 'winter'
    } else {
      state.theme = 'default'      
    }
  }
}